import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetListAttendanceFailed,
  actGetListAttendanceSuccess,
  MASTER_GET_LIST_ATTENDANCE,
} from '../../actions/attendance'
import { apiGetListAttendance } from '../../apis/attendance'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetList(action) {
  try {
    const response = yield call(apiGetListAttendance, action?.payload)

    if (response?.statusCode === 200) {
      const data = {
        data: response.data?.items,
        ...(response.data?.meta || {}),
      }
      yield put(actGetListAttendanceSuccess(data))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetListAttendanceFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetList() {
  yield takeLatest(MASTER_GET_LIST_ATTENDANCE, doGetList)
}
